import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { siteData } from "../mock";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const brand = siteData.brand.name;
  const letters = brand.split("");

  const scrollTo = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0a0a0a]/90 backdrop-blur-md border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
        {/* Logo */}
        <a
          href="#home"
          onClick={(e) => { e.preventDefault(); scrollTo("#home"); }}
          className="flex flex-col leading-none group"
        >
          <span className="font-wordmark font-bold text-3xl md:text-4xl tracking-wide">
            {letters.map((l, i) => (
              <span key={i} className={i === 3 ? "deal-yellow" : "text-white"}>{l}</span>
            ))}
          </span>
          <span className="font-wordmark text-white/95 text-lg md:text-xl tracking-wide mt-0.5">
            {siteData.brand.tagline}
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-9">
          {siteData.navigation.map((item) => (
            item.external ? (
              <a
                key={item.label}
                href={item.href}
                target={item.newTab ? "_blank" : undefined}
                rel={item.newTab ? "noopener noreferrer" : undefined}
                className="text-xs tracking-[0.25em] font-heading font-medium text-white/80 hover:text-[#e10600] transition-colors duration-200"
              >
                {item.label}
              </a>
            ) : (
              <a
                key={item.label}
                href={item.href}
                onClick={(e) => { e.preventDefault(); scrollTo(item.href); }}
                className="text-xs tracking-[0.25em] font-heading font-medium text-white/80 hover:text-[#e10600] transition-colors duration-200"
              >
                {item.label}
              </a>
            )
          ))}
        </nav>

        {/* Mobile Toggle */}
        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden text-white p-2 hover:text-[#e10600] transition-colors"
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div className="lg:hidden bg-[#0a0a0a]/98 backdrop-blur-md border-t border-white/5">
          <nav className="flex flex-col px-6 py-6 gap-4">
            {siteData.navigation.map((item) => (
              item.external ? (
                <a
                  key={item.label}
                  href={item.href}
                  target={item.newTab ? "_blank" : undefined}
                  rel={item.newTab ? "noopener noreferrer" : undefined}
                  className="text-sm tracking-[0.25em] font-heading text-white/85 hover:text-[#e10600] transition-colors py-2"
                >
                  {item.label}
                </a>
              ) : (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={(e) => { e.preventDefault(); scrollTo(item.href); }}
                  className="text-sm tracking-[0.25em] font-heading text-white/85 hover:text-[#e10600] transition-colors py-2"
                >
                  {item.label}
                </a>
              )
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
